<!-- @format -->
<works-tag>
  <div is="{ works.page }"></div>
  <script>
    import works from "@model/works/api";
    import form  from "@tags/parts/public-info/works/form.riot";
    import list  from "@tags/parts/public-info/works/list.riot";

    export default {
      components: {
        form: form,
        list: list,
      },
      works: works,
      listenerUpdate() {
        this.update()
      },
      onMounted(props, state) {
        this.works.trigger('list')
        this.works.on('update', this.listenerUpdate)
      },
      onUnmounted(props, state) {
        this.works.off('update', this.listenerUpdate)
      }
    };
  </script>
</works-tag>